var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPiczcenter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 89,
    width: 262,
    height: 261,
    rx: 24,
    fill: "black",
    stroke: "url(#paint0_linear_94_112)",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M228.6 116.71H97.2297C92.5077 116.71 88.6797 120.538 88.6797 125.26V220.06C88.6797 224.782 92.5077 228.61 97.2297 228.61H228.6C233.322 228.61 237.15 224.782 237.15 220.06V125.26C237.15 120.538 233.322 116.71 228.6 116.71Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224.92 110.82H93.55C88.828 110.82 85 114.648 85 119.37V214.17C85 218.892 88.828 222.72 93.55 222.72H224.92C229.642 222.72 233.47 218.892 233.47 214.17V119.37C233.47 114.648 229.642 110.82 224.92 110.82Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.998 162L101.258 172.3C98.5227 163.877 99.2446 154.712 103.265 146.821C107.286 138.93 114.276 132.958 122.698 130.22C126.018 129.109 129.498 128.554 132.998 128.58V162Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.002 162L152.632 189C145.468 194.202 136.531 196.346 127.787 194.96C119.042 193.574 111.206 188.772 106.002 181.61C103.918 178.79 102.317 175.644 101.262 172.3L133.002 162Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133 162L164.76 151.68C167.022 158.376 167.065 165.622 164.884 172.345C162.703 179.068 158.412 184.908 152.65 189L133 162Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133 162V128.6C140.072 128.52 146.982 130.722 152.703 134.879C158.424 139.037 162.652 144.929 164.76 151.68L133 162Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.05 182.8C144.549 182.8 153.87 173.479 153.87 161.98C153.87 150.481 144.549 141.16 133.05 141.16C121.552 141.16 112.23 150.481 112.23 161.98C112.23 173.479 121.552 182.8 133.05 182.8Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M221.551 126.56H175.801V130.35H221.551V126.56Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M211.711 134.67H175.801V138.46H211.711V134.67Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M202.191 142.78H175.801V146.57H202.191V142.78Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.301 150.89H175.801V154.68H213.301V150.89Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M193.621 159H175.801V162.79H193.621V159Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M221.551 167.12H175.801V170.91H221.551V167.12Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M209.491 175.23H175.801V179.02H209.491V175.23Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M205.241 183.34H175.801V187.13H205.241V183.34Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M221.551 191.45H175.801V195.24H221.551V191.45Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.02 202.5H151.48",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111 207.5H156.5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.02 202.5H212.48",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M172 207.5H217.5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M229.331 275.28H116.511C111.789 275.28 107.961 279.108 107.961 283.83V364.65C107.961 369.372 111.789 373.2 116.511 373.2H229.331C234.053 373.2 237.881 369.372 237.881 364.65V283.83C237.881 279.108 234.053 275.28 229.331 275.28Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M224.909 270.14H112.089C107.367 270.14 103.539 273.968 103.539 278.69V359.51C103.539 364.232 107.367 368.06 112.089 368.06H224.909C229.631 368.06 233.459 364.232 233.459 359.51V278.69C233.459 273.968 229.631 270.14 224.909 270.14Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M112.441 316.69H129.771",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M112.441 320.61H139.851",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M112.441 324.52H129.771",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M112.441 328.43H137.441",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M112.441 332.35H129.771",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M112.441 336.26H143.061",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M155.84 316.69H173.17",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M155.84 320.61H183.25",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M155.84 324.52H173.17",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M155.84 328.43H180.84",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M155.84 332.35H173.17",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M155.84 336.26H186.46",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M199.238 316.69H216.568",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M199.238 320.61H226.638",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M199.238 324.52H216.568",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M199.238 328.43H224.228",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M199.238 332.35H216.568",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M199.238 336.26H229.858",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M144.868 303.83H111.328V310.54H144.868V303.83Z",
    fill: "#263238"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M189.028 303.83H155.488V310.54H189.028V303.83Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M233.188 303.83H199.648V310.54H233.188V303.83Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M150.102 303.44V337.39",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M193.898 303.44V337.39",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M124.999 287.93L132.259 285.57C132.724 287.005 132.754 288.546 132.344 289.998C131.934 291.45 131.103 292.748 129.956 293.728C128.808 294.707 127.396 295.325 125.898 295.502C124.4 295.679 122.882 295.409 121.538 294.724C120.194 294.039 119.082 292.971 118.345 291.655C117.607 290.339 117.277 288.834 117.394 287.329C117.512 285.825 118.073 284.39 119.007 283.204C119.94 282.019 121.204 281.137 122.639 280.67C123.399 280.418 124.197 280.293 124.999 280.3V287.93Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M125 287.93V280.3C126.616 280.28 128.195 280.782 129.503 281.732C130.811 282.681 131.778 284.027 132.26 285.57L125 287.93Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M198.502 287.93L205.762 285.57C206.228 287.005 206.258 288.547 205.848 289.999C205.439 291.452 204.607 292.75 203.46 293.731C202.312 294.711 200.899 295.328 199.4 295.505C197.901 295.682 196.384 295.411 195.039 294.725C193.695 294.04 192.583 292.971 191.847 291.654C191.11 290.337 190.78 288.831 190.899 287.326C191.018 285.821 191.58 284.386 192.515 283.201C193.45 282.016 194.716 281.136 196.152 280.67C196.909 280.418 197.703 280.293 198.502 280.3V287.93Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M198.5 287.93V280.3C200.116 280.279 201.697 280.78 203.005 281.73C204.313 282.68 205.279 284.026 205.76 285.57L198.5 287.93Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M149.521 287.93V295.56C147.497 295.56 145.556 294.756 144.125 293.325C142.694 291.894 141.891 289.954 141.891 287.93C141.891 285.906 142.694 283.966 144.125 282.535C145.556 281.104 147.497 280.3 149.521 280.3V287.93Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M149.52 287.93V280.3C151.543 280.3 153.484 281.104 154.915 282.535C156.346 283.966 157.15 285.906 157.15 287.93C157.15 289.954 156.346 291.894 154.915 293.325C153.484 294.756 151.543 295.56 149.52 295.56V287.93Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M174.001 287.93L181.261 290.29C180.951 291.243 180.457 292.126 179.805 292.889C179.154 293.651 178.359 294.277 177.466 294.732C176.573 295.187 175.598 295.462 174.599 295.541C173.6 295.619 172.595 295.5 171.641 295.19C170.688 294.88 169.805 294.385 169.043 293.734C168.28 293.083 167.654 292.288 167.199 291.395C166.744 290.502 166.469 289.527 166.391 288.528C166.312 287.529 166.431 286.523 166.741 285.57C167.223 284.027 168.19 282.681 169.498 281.732C170.806 280.782 172.385 280.28 174.001 280.3V287.93Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M174 287.93V280.3C175.003 280.299 175.996 280.495 176.923 280.878C177.85 281.261 178.692 281.823 179.402 282.531C180.111 283.24 180.674 284.081 181.058 285.008C181.442 285.934 181.64 286.927 181.64 287.93C181.644 288.732 181.516 289.53 181.26 290.29L174 287.93Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M223.001 287.93L230.261 290.29C229.951 291.243 229.457 292.126 228.805 292.889C228.154 293.651 227.359 294.277 226.466 294.732C225.573 295.187 224.598 295.462 223.599 295.541C222.6 295.619 221.595 295.5 220.641 295.19C219.688 294.88 218.805 294.385 218.043 293.734C217.28 293.083 216.654 292.288 216.199 291.395C215.744 290.502 215.469 289.527 215.391 288.528C215.312 287.529 215.431 286.523 215.741 285.57C216.223 284.027 217.19 282.681 218.498 281.732C219.806 280.782 221.385 280.28 223.001 280.3V287.93Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M223 287.93V280.3C224.002 280.299 224.995 280.495 225.921 280.878C226.848 281.261 227.689 281.823 228.398 282.532C229.107 283.241 229.669 284.082 230.052 285.009C230.435 285.935 230.631 286.928 230.63 287.93C230.637 288.732 230.512 289.529 230.26 290.29L223 287.93Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M224.5 357.2H217.82V359.46H224.5V357.2Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M217.078 345.91H210.398V359.46H217.078V345.91Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M209.668 350.78H202.988V359.47H209.668V350.78Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M202.25 344H195.57V359.46H202.25V344Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M194.828 355.47H188.148V359.47H194.828V355.47Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M187.41 354.25H180.73V359.46H187.41V354.25Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M179.989 349.04H173.309V359.47H179.989V349.04Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M172.571 357.73H165.891V359.47H172.571V357.73Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M165.149 345.91H158.469V359.46H165.149V345.91Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M157.731 348.52H151.051V359.47H157.731V348.52Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M150.321 358.94H143.641V359.46H150.321V358.94Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M142.899 358.77H136.219V359.46H142.899V358.77Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M135.481 350.78H128.801V359.47H135.481V350.78Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M128.059 357.73H121.379V359.47H128.059V357.73Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M120.641 355.99H113.961V359.47H120.641V355.99Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M404.951 190.5H273.581C268.859 190.5 265.031 194.328 265.031 199.05V293.85C265.031 298.572 268.859 302.4 273.581 302.4H404.951C409.673 302.4 413.501 298.572 413.501 293.85V199.05C413.501 194.328 409.673 190.5 404.951 190.5Z",
    fill: "black"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M399.799 184.62H268.429C263.707 184.62 259.879 188.448 259.879 193.17V287.97C259.879 292.692 263.707 296.52 268.429 296.52H399.799C404.521 296.52 408.349 292.692 408.349 287.97V193.17C408.349 188.448 404.521 184.62 399.799 184.62Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M399.001 272.17H391.301V280.71H399.001V272.17Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M390.438 229.47H382.738V280.7H390.438V229.47Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M381.88 247.87H374.18V280.71H381.88V247.87Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M373.329 222.25H365.629V280.71H373.329V222.25Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M364.77 265.6H357.07V280.71H364.77V265.6Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M356.212 261H348.512V280.7H356.212V261Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M347.661 241.3H339.961V280.71H347.661V241.3Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M339.098 274.14H331.398V280.71H339.098V274.14Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M330.54 229.47H322.84V280.7H330.54V229.47Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M321.989 239.33H314.289V280.71H321.989V239.33Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M313.43 278.73H305.73V280.7H313.43V278.73Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M304.872 278.08H297.172V280.71H304.872V278.08Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M296.309 247.87H288.609V280.71H296.309V247.87Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M287.759 274.14H280.059V280.71H287.759V274.14Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M279.2 267.57H271.5V280.71H279.2V267.57Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M399.5 208H272.5V214.5H399.5V208Z",
    fill: "#FD1065",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M326.561 208.47H305.961V214.02H326.561V208.47Z",
    fill: "#263238",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M366.081 208.47H327.391V214.02H366.081V208.47Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M388.75 69.61H285.71C280.988 69.61 277.16 73.438 277.16 78.16V151.61C277.16 156.332 280.988 160.16 285.71 160.16H388.75C393.472 160.16 397.3 156.332 397.3 151.61V78.16C397.3 73.438 393.472 69.61 388.75 69.61Z",
    fill: "black"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M384.328 63.73H281.288C276.566 63.73 272.738 67.5579 272.738 72.28V145.73C272.738 150.452 276.566 154.28 281.288 154.28H384.328C389.05 154.28 392.878 150.452 392.878 145.73V72.28C392.878 67.5579 389.05 63.73 384.328 63.73Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M278.32 145.8H391.12",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M278.32 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M285.84 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M293.359 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M300.879 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M308.398 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M315.922 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M323.441 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M330.961 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M338.48 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M346 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M353.52 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M361.039 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M368.559 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M376.078 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M383.602 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M391.121 145.8V147.47",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M282.078 144.44H387.358V129.89L379.908 115.49C379.86 115.389 379.826 115.281 379.808 115.17L373.188 72.46C373.188 72.2479 373.104 72.0444 372.954 71.8943C372.804 71.7443 372.6 71.66 372.388 71.66C372.176 71.66 371.972 71.7443 371.822 71.8943C371.672 72.0444 371.588 72.2479 371.588 72.46L364.848 124.6C364.816 124.85 364.691 125.078 364.498 125.24L358.008 130.24C357.915 130.31 357.806 130.357 357.692 130.378C357.577 130.399 357.459 130.393 357.347 130.361C357.235 130.329 357.131 130.272 357.045 130.194C356.958 130.115 356.891 130.018 356.848 129.91L350.308 116.42C350.26 116.293 350.178 116.182 350.072 116.098C349.965 116.015 349.838 115.961 349.704 115.944C349.57 115.926 349.433 115.945 349.309 115.999C349.184 116.053 349.077 116.14 348.998 116.25L342.238 125L334.718 134.7L327.198 125L320.568 116.45C320.481 116.331 320.361 116.239 320.223 116.187C320.085 116.134 319.934 116.123 319.79 116.155C319.646 116.187 319.514 116.26 319.41 116.366C319.307 116.472 319.237 116.605 319.208 116.75L312.208 138.58L304.688 99.67L297.168 142.46L289.648 136.64L283.648 119.74C283.308 118.74 282.088 119.06 282.088 120.1L282.078 144.44Z",
    fill: "#FD1065"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M387.358 144.47H282.078V132L289.518 119.62C289.57 119.534 289.604 119.439 289.618 119.34L296.238 82.6099C296.274 82.423 296.375 82.2546 296.521 82.1334C296.668 82.0123 296.853 81.946 297.043 81.946C297.234 81.946 297.418 82.0123 297.565 82.1334C297.712 82.2546 297.812 82.423 297.848 82.6099L304.578 127.45C304.621 127.674 304.75 127.871 304.938 128L311.428 132.32C311.521 132.382 311.626 132.425 311.737 132.445C311.847 132.464 311.961 132.461 312.07 132.435C312.179 132.408 312.281 132.36 312.37 132.292C312.46 132.224 312.534 132.138 312.588 132.04L319.118 120.44C319.182 120.328 319.271 120.232 319.378 120.162C319.486 120.091 319.609 120.047 319.737 120.033C319.865 120.02 319.995 120.037 320.115 120.083C320.235 120.129 320.342 120.204 320.428 120.3L327.198 127.8L334.718 136.14L342.238 127.8L348.858 120.45C348.952 120.347 349.072 120.27 349.204 120.226C349.337 120.182 349.478 120.172 349.616 120.198C349.753 120.224 349.881 120.285 349.988 120.375C350.095 120.464 350.178 120.58 350.228 120.71L357.228 139.48H364.748L372.268 142.82L379.788 137.82L385.788 123.29C385.855 123.109 385.983 122.957 386.152 122.862C386.32 122.768 386.516 122.736 386.706 122.774C386.895 122.811 387.065 122.915 387.184 123.066C387.304 123.218 387.366 123.407 387.358 123.6V144.47Z",
    fill: "#263238"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M339.09 75.7999H362.39",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M339.09 81.26H362.39",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M339.09 86.71H362.39",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M339.09 92.17H362.39",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M339.09 97.62H362.39",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M339.09 103.08H362.39",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M333.789 75.7999H336.709",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M333.789 81.26H336.709",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M333.789 86.71H336.709",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M333.789 92.17H336.709",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M333.789 97.62H336.709",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M333.789 103.08H336.709",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_94_112",
    x1: 109,
    y1: 219.5,
    x2: 373,
    y2: 219.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#E30147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#EC36B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604167,
    stopColor: "#A856EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#9865FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4876FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiczcenter);
export default __webpack_public_path__ + "static/media/piczcenter.c951cf76a794cd3c461f3a9bf7bb5569.svg";
export { ForwardRef as ReactComponent };